module.exports = __webpack_public_path__ + "img/box8-3.d4372d46.png";